import script from "./KiiviComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./KiiviComponent.vue?vue&type=script&setup=true&lang=js"

import "./KiiviComponent.vue?vue&type=style&index=0&id=358858f4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-358858f4"]])

export default __exports__